let currentToken = null;
// Inicializa refresh token a partir do sessionStorage (se existir)
let currentRefreshToken = null;
try {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const saved = window.sessionStorage.getItem('erm_refresh_token');
    if (saved) currentRefreshToken = saved;
  }
} catch (_) {
  // ignore storage errors (Safari private mode, etc.)
}
const logoutSubscribers = new Set();

function setToken(token) {
  currentToken = token || null;
}

function getToken() {
  return currentToken;
}

function setRefreshToken(token) {
  currentRefreshToken = token || null;
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      if (currentRefreshToken) {
        window.sessionStorage.setItem('erm_refresh_token', currentRefreshToken);
      } else {
        window.sessionStorage.removeItem('erm_refresh_token');
      }
    }
  } catch (_) {
    // ignore
  }
}

function getRefreshToken() {
  return currentRefreshToken;
}

function clearRefreshToken() {
  currentRefreshToken = null;
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.removeItem('erm_refresh_token');
    }
  } catch (_) {
    // ignore
  }
}

function clearToken() {
  currentToken = null;
  currentRefreshToken = null;
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.removeItem('erm_refresh_token');
    }
  } catch (_) {
    // ignore
  }
  logoutSubscribers.forEach(cb => {
    try {
      cb();
    } catch (e) {
      // noop
    }
  });
}

function onLogout(callback) {
  logoutSubscribers.add(callback);
  return () => logoutSubscribers.delete(callback);
}

export {
  setToken,
  getToken,
  setRefreshToken,
  getRefreshToken,
  clearRefreshToken,
  clearToken,
  onLogout,
};

export default {
  setToken,
  getToken,
  setRefreshToken,
  getRefreshToken,
  clearRefreshToken,
  clearToken,
  onLogout,
};
